import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Procesos from './Procesos.jsx';
import * as actions from "../actions/Actions.js";
  
const mapStateToProps = (state) => { 
       return {
        data:state.procesos
    }
}

const mapDispatchToProps = (dispatch) =>{
    return bindActionCreators(actions, dispatch)
 } 

 
//Connect entre el componente y las props y actions.
const ProcesosContainer = connect(mapStateToProps, mapDispatchToProps)(Procesos);

export default ProcesosContainer;